import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  submit: {
    id: 'studio.jvo0vs',
    defaultMessage: 'Save',
  },
  uploadError: {
    id: 'studio.J+5t/+',
    defaultMessage: 'Something went wrong when trying to upload messages for this language.',
  },
  uploadSuccess: {
    id: 'studio.BSgbsk',
    defaultMessage: 'Uploaded messages successfully',
  },
  messageIds: {
    id: 'studio.XkOni/',
    defaultMessage: 'Custom messages',
  },
  app: {
    id: 'studio.3fhxaY',
    defaultMessage: 'App messages',
  },
  block: {
    id: 'studio.Ot0Rto',
    defaultMessage: 'Block messages',
  },
  core: {
    id: 'studio.StY0h2',
    defaultMessage: 'Core messages',
  },
});
